// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".placeholder-italic[data-v-208ed642]:hover {\n  border: 0.5px solid rgba(168, 174, 184, 0.50) !important;\n  background: #FFF !important;\n}\n.placeholder-black[data-v-208ed642]:hover {\n  border: 1px solid #F2B705;\n}\n.resumeSkill[data-v-208ed642] {\n  background-color: #DBF6EB !important;\n}\n.resumeSkill>span[data-v-208ed642] {\n  color: #0DB952 !important;\n}\n", ""]);
// Exports
module.exports = exports;
